module.exports = __webpack_public_path__ + "img/SC12-Next_steps.f5391371.png";